export const THOUSANDS_SEPARATOR = '';
export const DECIMAL_SEPARATOR = '.';
export const DEGREES = 'degrees';
export const RADIANS = 'radians';
// same as math.js EPSILON value, see https://mathjs.org/docs/core/configuration.html
// this prevents expressions like sin(30deg) from returning floating-point errors like 0.499999999
export const PRECISION = 12;
